import { Component, OnInit } from '@angular/core';
import { CartService } from '../cart.service';
import { SharedService } from '../../shared.service';
import * as moment from 'moment';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit {
  public ticketPrice: Number = 0;
  public maxGain: Number = 0;
  public odds: Number = 0;
  public serviceFee: Number = 0;
  public pension: Boolean = false;
  public environment: string;
  public backPay: number = 0;
  public lotteryNumber = null;
  public lotteryStartDate = null;
  public env: String = this.sharedService.getEnvironment();

  constructor(
    private cartService: CartService,
    private sharedService: SharedService
  ) {
    this.pension =
      sharedService.getLotterySource() === 'pension' ? true : false;
    this.environment = this.sharedService.getEnvironment();
  }

  ngOnInit() {
    /*
     * Subscribes the EventEmitter from
     * CartService and updates local properties
     * if values have changed.
     */
    this.cartService.cartUpdated.subscribe((calculatedProduct) => {
      this.ticketPrice = calculatedProduct.stake;
      this.maxGain = calculatedProduct.maxGain;
      this.serviceFee = calculatedProduct.lottery.serviceFee;
      this.odds = calculatedProduct.odds || 0;
      this.backPay = calculatedProduct.backPay || 0;

      const startDate = moment(calculatedProduct.lottery.start);
      this.lotteryNumber = this.cartService.getLotteryNumber();
      this.lotteryStartDate = startDate.format('DD.MM.YYYY');
    });
  }

  getTooltipText() {
    const text = `Die ${this.lotteryNumber}. Lotterie hat bereits am ${this.lotteryStartDate} begonnen. Sie haben noch die Möglichkeit in die laufende Lotterie einzusteigen. Für bereits abgelaufene Klassen müssen Sie Ihren Einsatz nachentrichten. Dies gilt nicht für die Joker Spiele.`;
    return text;
  }
}
